import React, { useContext, useEffect } from 'react'
import { makeStyles, tokens, mergeClasses, TabList, SelectTabData } from '@fluentui/react-components'
import { useNavigate, useLocation } from 'react-router-dom'
import { Text } from '../text/Text'
import { DataContext } from '../../../context/DataContext'
import { BaseNavLinks } from './BaseNavLinks'
import { NavigationLink } from '../../../interfaces/INavigationLink'

type NavigationProps = {
   activeDesktopLink: NavigationLink
   customOnTabSelect?: (e: any, data: SelectTabData) => void
   phoneNavLinks?: JSX.Element[] | JSX.Element
   activePhoneTab?: string
}
const useStyles = makeStyles({
   nav: {
      position: 'fixed',
      boxShadow: tokens.shadow8,
      zIndex: 3,
      backgroundColor: tokens.colorNeutralBackground1,
      paddingLeft: '2px',
      paddingRight: '2px',
      left: 0,
   },
   desktopNav: {
      display: 'flex',
      justifyContent: 'space-between',
      height: 'calc(100vh - 60px)',
      top: '60px',
      width: '60px',
      flexDirection: 'column',
      '@media screen and (max-width: 1007px)': {
         paddingLeft: tokens.spacingVerticalL,
         paddingTop: tokens.spacingHorizontalM,
      },
   },
   phoneNav: {
      display: 'none',
      '@media screen and (max-width: 1007px)': {
         display: 'flex',
         bottom: 0,
         width: '100%',
         height: '50px',
         justifyContent: 'center',
         top: 'auto',
      },
   },
   expanded: {
      width: '316px',
      alignItems: 'start',
      backgroundColor: tokens.colorNeutralBackground1,
   },
   hiddenInPhone: {
      '@media screen and (max-width: 1007px)': {
         display: 'none',
      },
   },
   tabList: {
      width: '100%',

      '& button': {
         paddingLeft: '18px',
      },
      '@media screen and (max-width: 1007px)': {
         justifyContent: 'space-around',
         '& button': {
            paddingLeft: '10px',
         },
      },
   },
   versionNr: {
      paddingLeft: tokens.spacingHorizontalXXS,
   },
})

export const Navigation = ({ customOnTabSelect, phoneNavLinks, activeDesktopLink, activePhoneTab }: NavigationProps) => {
   const dataContext = useContext(DataContext)
   const packageJson = require('../../../../package.json')
   const { navigationExpanded } = dataContext.state
   const classes = useStyles()
   const navigate = useNavigate()
   const location = useLocation()
   const onTabSelect = customOnTabSelect
      ? customOnTabSelect
      : (e: any, data: SelectTabData) => {
           data.value === location.pathname
              ? dataContext.setRootState((prev) => ({
                   ...prev,
                   navigationExpanded: false,
                }))
              : navigate(data.value)
        }

   useEffect(() => {
      if (navigationExpanded) {
         dataContext.setRootState((prev) => ({
            ...prev,
            navigationExpanded: false,
         }))
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location.pathname, location.search])

   return (
      <>
         <aside className={mergeClasses(classes.nav, classes.desktopNav, navigationExpanded ? classes.expanded : classes.hiddenInPhone)}>
            <TabList vertical selectedValue={activeDesktopLink} size="large" onTabSelect={onTabSelect} className={classes.tabList}>
               <BaseNavLinks active={activeDesktopLink} />
            </TabList>
            <Text className={classes.versionNr} size={300}>
               {packageJson.version}
            </Text>
         </aside>
         <footer className={mergeClasses(classes.nav, phoneNavLinks ? classes.phoneNav : '', navigationExpanded ? classes.expanded : '')}>
            <TabList selectedValue={activePhoneTab ? activePhoneTab : activeDesktopLink} size="large" onTabSelect={onTabSelect} className={classes.tabList}>
               {phoneNavLinks}
            </TabList>
         </footer>
      </>
   )
}
